// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_dh-0";
export var fileCarousel = "_dh-2";
export var removeFileButton = "_dh-1";